import { IdPackageType } from '@cbinsights/externalapiservice/externalapiservice';

export const packageTypeToLabel = {
  [IdPackageType.ID_PACKAGE_TYPE_UNSPECIFIED]: '',
  [IdPackageType.ESSENTIAL_PER_ORG]: 'Essential',
  [IdPackageType.EXPERT_PER_ORG]: 'Expert',
  [IdPackageType.LEGACY_PER_REQUEST]: 'Legacy',
  [IdPackageType.V2_ONLY]: 'v2 Only',
  [IdPackageType.UNRECOGNIZED]: '',
} as const;

export const dateFormat = 'YYYY-MM-DD';
